module.exports = "<div class=\"container\">\n    <div class=\"box\">\n        <div class=\"logo\">\n            <img src=\"" + require("../../../../public/images/logo_geosiap.png") + "\" width=\"185\" height=\"49\" alt=\"Logo GeoSiap\">\n        </div>\n\n        <h1>Projeto não informado.</h1>\n        <p>Informe o projeto que você deseja acessar. <br />\n            Por exemplo <i>{{domain}}</i><strong>nome-do-projeto</strong>\n        </p>\n    </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/pages/not-tenant-page/not-tenant-page.component.html
 ** module id = 1055
 ** module chunks = 0
 **/